module.exports = __webpack_public_path__ + "static/media/button-wizard-6.cba7fe52.png";